import { Component } from '@angular/core';

@Component({
    selector: 'unsupported-market',
    templateUrl: './unsupported-market.component.html'
})

export class UnsupportedMarketComponent { }
